var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"img"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgShow),expression:"imgShow"}],attrs:{"src":'data:image/jpeg;base64,' + _vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }